import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxLineClampModule } from 'ngx-line-clamp';
import { LineTruncationDirective, LineTruncationLibModule } from 'ngx-line-truncation';
// components
import { HeaderComponent } from './components/header/header.component';
import { HeaderSmallComponent } from './components/header-small/header-small.component';
import { CheckoutBtnComponent } from './components/checkout-btn/checkout-btn.component';
import { NotificationModalComponent } from './components/notification-modal/notification-modal.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SmartHeaderDirective } from './directives/smart-header.directive';
import { OrderStatusComponent } from './components/order-status/order-status.component';
import { CartComponent } from './components/cart/cart.component';
import { CartItemComponent } from './components/cart-item/cart-item.component';
import { ProductModalComponent } from './components/product-modal/product-modal.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { PickUpDateTimeComponent } from '../pages/checkout/components/pick-up-date-time/pick-up-date-time.component';
import { TipRadioGroupComponent } from '../pages/checkout/components/tip-radio-group/tip-radio-group.component';
import { ScheduledPickupTimepickerComponent } from '../pages/checkout/components/scheduled-pickup-timepicker/scheduled-pickup-timepicker.component';
import { TippingComponent } from '../pages/restaurant/components/tipping/tipping.component';
import { OrdersStatusComponent } from './components/orders-status/orders-status.component';
// services
import { RouteService } from '../core/services/route.service';
import { TabOrderStatusComponent } from './components/tab-order-status/tab-order-status.component';
import { TabOrdersStatusComponent } from './components/tab-orders-status/tab-orders-status.component';
import { HeaderTextPopoverComponent } from './components/header-text-popover/header-text-popover.component';
import { AgeGateModalComponent } from '../pages/restaurant/components/age-gate-modal/age-gate-modal.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MatSliderModule } from '@angular/material/slider';
import { LocationListComponent } from './components/location-list/location-list.component';
import { TabModalComponent } from '../pages/restaurant/components/tab-modal/tab-modal.component';
import { RestaurantClosedModalComponent } from '../pages/restaurant/components/restaurant-closed-modal/restaurant-closed-modal.component';
import { LoyaltyBannerComponent } from './components/loyalty-banner/loyalty-banner.component';
import { MultiselectComponent } from '../pages/checkout/components/multiselect/multiselect.component';
import { BillingAddressComponent } from '../pages/checkout/components/billing-address/billing-address.component';
import { VerifyPhoneNumberComponent } from './components/verify-phone-number/verify-phone-number.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { TextMaskModule } from 'angular2-text-mask';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { SmsCodeComponent } from './components/sms-code/sms-code.component';
import { MatFormFieldModule } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';
import { CurrentOrdersService } from '../core/services/current-orders.service';
import { ItemService } from '../core/services/item.service';
import {TableRedirectService} from '../core/services/TableRedirectService';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatExpansionModule} from "@angular/material/expansion";
import {
  SharedOrdersModalComponent
} from "../pages/restaurant/components/shared-orders-modal/shared-orders-modal.component";
import { QRCodeModule } from 'angularx-qrcode';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {GoogleMapsModule} from '@angular/google-maps';
import {
  ThrottlingConfirmationComponent
} from './components/product-modal/throttling-confirmation/throttling-confirmation.component';
import {OrderOnlyModalComponent} from './components/order-only-modal/order-only-modal.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    IonicModule,
    // For TippingComponent
    CurrencyMaskModule,
    LineTruncationLibModule,
    NgxLineClampModule,
    LazyLoadImageModule,
    MatSliderModule,
    NgOtpInputModule,
    TextMaskModule,
    NgxIntlTelInputModule,
    NgOtpInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatExpansionModule,
    QRCodeModule,
    MatIconModule,
    MatButtonModule,
    MatProgressBarModule,
    GoogleMapsModule
  ],
  declarations: [
    HeaderComponent,
    HeaderSmallComponent,
    CheckoutBtnComponent,
    NotificationModalComponent,
    // Temporary fix
    PickUpDateTimeComponent,
    TipRadioGroupComponent,
    ScheduledPickupTimepickerComponent,
    TippingComponent,
    SpinnerComponent,
    SmartHeaderDirective,
    OrderStatusComponent,
    CartComponent,
    ProductModalComponent,
    ProductDetailsComponent,
    CartItemComponent,
    OrdersStatusComponent,
    HeaderTextPopoverComponent,
    OrdersStatusComponent,
    TabOrderStatusComponent,
    TabOrdersStatusComponent,
    AgeGateModalComponent,
    RestaurantClosedModalComponent,
    TabModalComponent,
    LocationListComponent,
    LoyaltyBannerComponent,
    MultiselectComponent,
    BillingAddressComponent,
    VerifyPhoneNumberComponent,
    SideMenuComponent,
    SmsCodeComponent,
    SharedOrdersModalComponent,
    ThrottlingConfirmationComponent,
    OrderOnlyModalComponent
  ],
  exports: [
    HeaderComponent,
    HeaderSmallComponent,
    CheckoutBtnComponent,
    NotificationModalComponent,
    SpinnerComponent,
    SmartHeaderDirective,
    OrderStatusComponent,
    CartItemComponent,
    ProductModalComponent,
    ProductDetailsComponent,
    // Temporary fix
    PickUpDateTimeComponent,
    TipRadioGroupComponent,
    ScheduledPickupTimepickerComponent,
    TippingComponent,
    TabOrderStatusComponent,
    AgeGateModalComponent,
    TabModalComponent,
    RestaurantClosedModalComponent,
    LoyaltyBannerComponent,
    MultiselectComponent,
    BillingAddressComponent,
    LineTruncationDirective,
    VerifyPhoneNumberComponent,
    SideMenuComponent,
    SmsCodeComponent,
    OrderOnlyModalComponent
  ],
  providers: [
    RouteService,
    CookieService,
    CurrentOrdersService,
    ItemService,
    TableRedirectService
  ],
})
export class SharedModule {}
